import React from 'react';
import Col from 'react-bootstrap/Col';

const DniTemplate = ({ mt15, isBrowserCol12, dniTypes, dni, isBrowserMt, labelGrid, contentGrid }) => {
    
    const cedulaFormat = (phone) => {
        if (phone.length == 11) { 
            return `${phone.substring(0,3)}-${phone.substring(3,10)}-${phone.substring(10,11)}`
        } else {
            return phone
        }
    }

    return (
        <>
            <Col style={mt15} xs={labelGrid}>
                <strong> { dniTypes.length > 0 && 
                    dniTypes.find(x => x.id == dni.dniTipoId)?.nombre
                } </strong>
            </Col>
            <Col style={isBrowserMt} xs={contentGrid}>
                { dni.dniTipoId  == 1 ? cedulaFormat(dni.dni) : dni.dni }
            </Col>
        </>
    );
};

export default (DniTemplate);